import React, { useCallback } from 'react';
import { BrowserRouter, Route, useHistory, useLocation } from 'react-router-dom';
import get from 'lodash/get';
import SplashPage from 'feature/splash';
import { helperUrl } from 'config';
import { useAppContext, HIDE_APP_MESSAGE, SET_CUSTOMER_SERVICE_DIALOG, SET_LINE_BANK_LOGIN_DIALOG } from 'use-app';
import AppMessage from 'components/app-message';
import Toast from 'components/toast';
import BottomTab from 'components/bottom-tab';
import ButtonDialog from 'components/button-dialog';
import appLoader from 'distributor/app-loader';
import { openLink } from 'helpers/link-helper';
import RefuelingRequestDialog from 'components/refueling-request-dialog';
import RefuelingProcessingDialog from 'components/refueling-processing-dialog';
import { isLineBank, config, PATH } from 'config';

const RoutingContent = ({ routing, configData }) => {
  const { state, dispatch } = useAppContext();
  const history = useHistory();
  const location = useLocation();

  return (
    <>
      {routing.map((route, key) => (
        <RouteComponent route={route} state={state} key={key} />
      ))}
      <BottomTab tabs={configData.bottomTabList} />
      <RefuelingRequestDialog refuelingRequest={state.refuelingRequest} />
      <RefuelingProcessingDialog isShow={state.isRefuelingRequestProcessing} />
      <ButtonDialog
        isShow={state.lineBankLoginDialog}
        title="立即連結服務"
        horizonal
        items={[
          {
            content: '連結帳號',
            theme: 'positive',
            onClick: () => (window.location.href = config.lineBankBindPage),
          },
          {
            content: '稍後',
            theme: 'cancel',
            onClick: () => {
              dispatch({ type: SET_LINE_BANK_LOGIN_DIALOG, payload: false });
            },
          },
        ]}
      >
        請先連結您的 LINE Bank 簽帳金融卡，才能開始使用加油停車快速付款服務。
      </ButtonDialog>
      <ButtonDialog
        isShow={state.customerServiceDialog}
        title="聯絡客服"
        items={[
          {
            content: '幫助中心',
            theme: 'positive',
            onClick: () => openLink(isLineBank ? config.lineBankHelperUrl : helperUrl),
          },
          {
            content: '聯絡客服',
            theme: 'positive',
            onClick: () => {
              dispatch({
                type: SET_CUSTOMER_SERVICE_DIALOG,
                payload: false,
              });
              history.push({
                pathname: PATH.CONTACT,
                state: { from: location.pathname },
              });
            },
          },
          {
            content: '取消',
            theme: 'cancel',
            onClick: () => {
              dispatch({
                type: SET_CUSTOMER_SERVICE_DIALOG,
                payload: false,
              });
            },
          },
        ]}
      />
    </>
  );
};

const RouteComponent = ({ route, state }) => {
  if (route.hasOwnProperty('render')) {
    return route.render(state);
  }

  if (route.hasOwnProperty('provider')) {
    let Provider = route.provider;

    const Content = () => {
      return (
        <Provider>
          {route.routes.map(r => {
            return (
              <Route
                key={r.path}
                exact
                path={r.path}
                component={props => {
                  return r.component(props);
                }}
              />
            );
          })}
        </Provider>
      );
    };

    if (route.path) {
      return <Route path={route.path}>{Content()}</Route>;
    } else {
      return Content();
    }
  }

  return <Route exact path={route.path} component={route.component}></Route>;
};

const Router = () => {
  const { routing, configData } = appLoader;
  const { state, dispatch } = useAppContext();

  const onAppMessageDismiss = useCallback(() => {
    dispatch({ type: HIDE_APP_MESSAGE });
  }, [dispatch]);

  if (state.pending) {
    return (
      <BrowserRouter>
        <Route path="*" component={SplashPage} />
      </BrowserRouter>
    );
  }

  return (
    <>
      <BrowserRouter>
        <RoutingContent routing={routing} state={state} configData={configData} />
      </BrowserRouter>

      <AppMessage
        type={get(state.appMessage, 'type')}
        isShow={state.appMessage !== null}
        onDismiss={onAppMessageDismiss}
      >
        {get(state.appMessage, 'message', '')}
      </AppMessage>
      <Toast isShow={state.toastMessage !== null}>{get(state, 'toastMessage', '')}</Toast>
    </>
  );
};

export default Router;
